import _ from "lodash";
import React, { memo, useCallback, useMemo } from "react";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { Dropdown, DropdownMenu, FilterLabelButton } from "@toddle-edu/ds-web";
import { useTranslation } from "react-i18next";

const TEST_ID_PREFIX = "transcript-studentPreview-templateSwitcher";

const TemplateSwitcher = ({
  isLoading,
  templates,
  selectedTemplate,
  setTemplateId,
}) => {
  const { t } = useTranslation();
  const options = useMemo(
    () =>
      _.map(templates, ({ id, name }) => ({
        key: id,
        label: name || t("common:untitled"),
      })),
    [templates, t]
  );

  const handleClick = useCallback(
    ({ key }) => {
      setTemplateId(key);
    },
    [setTemplateId]
  );

  if (isLoading) return <SkeletonLoader height="36px" width="300px" />;
  if (_.isEmpty(templates)) return null;

  return (
    <Dropdown
      overlay={
        <DropdownMenu
          options={options}
          onClick={handleClick}
          showSelection
          value={selectedTemplate?.id}
          testId={TEST_ID_PREFIX}
          overlayHeight={188}
        />
      }
    >
      <FilterLabelButton
        label={t("common:template")}
        labelValue={selectedTemplate?.name || t("common:untitled")}
        type="outlined"
        variant="neutral"
        testId={TEST_ID_PREFIX}
      />
    </Dropdown>
  );
};

export default memo(TemplateSwitcher);
